import { scrollToElement } from './_utils.js'

export default function () {
  const jumpLink = document.querySelector('.Footer-jumpLink')
  const jumpLinkTarget = document.querySelector('.Footer-contactSection')

  if (jumpLink) {
    jumpLink.addEventListener('click', (event) => {
      event.preventDefault()
      scrollToElement(jumpLinkTarget)
      document.getElementById('Footer-focusHeader').focus()
    })
  }
}
